import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { WUExtendPropsType, initDataType } from '../../system/WebUniversalNewEx';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import { useRef, useState } from 'react';
import { Button,Image } from 'antd';
import BuyerProudctEdit from './BuyerProudctEdit';
import BuyerProductTransfer from './BuyerProductTransfer';

export default function DeptProduct(props: any) {
    const ref = useRef<any>(undefined);
    const { data, closeModal } = props;
    const { buyerId } = data

    const [productTransferModel, setProductTransferModel] = useState<boolean>(false);
    const [estimateTransferData, setEstimateTransferData] = useState<any>();
    let apiId = "buyerProuduct"
    //表头
    const columnsHead = [

        {
            title: '产品',
            dataIndex: 'product',
            render: (text: any, record: any) => {

                return <div>{text.productName}</div>
            }
        },
        {
            title: '单位',
            dataIndex: 'product',
            render: (text: any, record: any) => {

                return <div>{text.productUnit.productUnitName}</div>
            }
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
          {
            title: '产品合格证',
            dataIndex: 'productCertificateUrl',
            render: (text: any, record: any) => (
                text?
                < Image
                    src={text}
                    width={80}
                    height={80}
                    alt="图片" />:null
            )
        },


    ];
  

    /** 子表头 */
    const handleOk = (e: any) => {
        closeModal(true);
    };
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '采购商产品',
        apiId,
        showStates: true,
        sendPageData: { buyerId },
        columns,
        pagination: true,
        EditComponent: BuyerProudctEdit,
        // isExpandable: true,
        // expandableColumns,
        // expandableDataName: 'productSpecs',
    };
    // 沽清穿梭框处理
    const handleEstimateTransfer = () => {

        setEstimateTransferData({ buyerId })
        setProductTransferModel(true);
    };
    //关闭穿梭框页面
    const onCloseEstimateTransfer = async (status: boolean) => {


        setProductTransferModel(false);
        if (status) {
            const currentData: initDataType = {
                apiId,

            }
            ref.current.initData(currentData)
        }
    }
    return (
        <>
            <AntDraggableModal
                title={'采购商产品'}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={handleOk}
                closable={false}
                maskClosable={false}
                width={800}>
                <Button type="primary" onClick={handleEstimateTransfer}>添加采购商产品</Button>
                <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
            </AntDraggableModal>

            {productTransferModel
                ? (<BuyerProductTransfer
                    closeModal={onCloseEstimateTransfer} data={estimateTransferData} />)
                : null}

        </>

    )
}
